import React, { Component } from 'react';
import { Table, Row } from 'reactstrap';
import { setMonthlyData, getTableHeaders, getTableValues } from './helper';
import '../style.scss'

class VerticalDataModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            monthlyData: []
        }
    }
    render() {
        const tableHeaders = getTableHeaders(this.props.paymentMonthlyDataId, this.props.paymentValue)
        const tableValue = setMonthlyData(this.props.paymentMonthlyDataId, this.props.paymentValue)
        return (
            <div>
                <Row>
                    <span className='conversion-unit-modal'><b>Conversion Unit:</b> {this.props.conversionUnit}</span>
                </Row>
                <Row>
                    <Table striped responsive bordered size="lg" className='table-payment-data'>
                        <thead>
                            <tr>
                                {
                                    (tableHeaders) ?
                                        tableHeaders.map(data => {
                                            return (

                                                <th width='100' key={data.name}>{data.headerName}</th>
                                            )
                                        }) : null
                                }
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {
                                    (tableValue) ? tableValue.map(data => {
                                        return (
                                            <td scope='row' key={data.name}>{(data.value) ? getTableValues(data.value) : '-'}</td>
                                        )
                                    }) : null
                                }
                            </tr>
                        </tbody>
                    </Table>
                </Row>
            </div>
        )
    }
}

export default VerticalDataModal